/* Cellulight Gold — shared behaviour */
(function () {
  'use strict';

  /* ---------- header: transparent over the hero, white past it ----------
     Pages with no hero (the PDP) keep it solid from the start. */
  var hdr = document.getElementById('hdr');
  var heroEl = document.querySelector('.hero');
  if (hdr && !heroEl) hdr.classList.add('solid');
  if (hdr && heroEl) {
    var onScroll = function () {
      hdr.classList.toggle('solid', heroEl.getBoundingClientRect().bottom <= hdr.offsetHeight);
    };
    /* first read in a frame, never at boot: nothing forces layout before first paint */
    requestAnimationFrame(onScroll);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* ---------- mobile nav ---------- */
  var mnav = document.getElementById('mnav');
  var burger = document.getElementById('burger');
  var mclose = document.getElementById('mclose');
  var toggle = function (open) {
    if (!mnav) return;
    mnav.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  };
  if (burger) burger.addEventListener('click', function () { toggle(true); });
  if (mclose) mclose.addEventListener('click', function () { toggle(false); });
  if (mnav) mnav.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () { toggle(false); });
  });

  /* ---------- payment icons (original brand marks + colours) ---------- */
  var CARDS = [
    { i: 'fa-cc-visa',      c: '#1434CB', l: 'Visa' },
    { mc: true,             l: 'Mastercard' },
    { i: 'fa-cc-amex',      c: '#006FCF', l: 'American Express' },
    { i: 'fa-cc-discover',  c: '#F26E21', l: 'Discover' },
    { i: 'fa-cc-paypal',    c: '#003087', l: 'PayPal' },
    { i: 'fa-cc-apple-pay', c: '#000000', l: 'Apple Pay' },
    { i: 'fa-google-pay',   c: '#5F6368', l: 'Google Pay' },
    { i: 'fa-shopify',      c: '#5A31F4', l: 'Shop Pay' }
  ];
  var cardHTML = function (k) {
    var inner = k.mc
      ? '<svg viewBox="0 0 32 20" width="26" height="16" aria-hidden="true">' +
        '<circle cx="12.5" cy="10" r="8" fill="#EB001B"/>' +
        '<circle cx="19.5" cy="10" r="8" fill="#F79E1B"/>' +
        '<path fill="#FF5F00" d="M16 4.2a8 8 0 0 0 0 11.6 8 8 0 0 0 0-11.6Z"/></svg>'
      : '<i class="fa-brands ' + k.i + '" style="color:' + k.c + '"></i>';
    /* role="img": aria-label is prohibited on a bare span and is dropped by screen readers */
    return '<span class="pay-card" role="img" title="' + k.l + '" aria-label="' + k.l + '">' + inner + '</span>';
  };
  document.querySelectorAll('.pay-row').forEach(function (row) {
    row.innerHTML = CARDS.map(cardHTML).join('');
  });

  /* ---------- scroll reveal ----------
     Attributes are applied from JS, so with JS off nothing is ever hidden. */
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- hero video card ----------
     video_tag writes autoplay into the markup, so someone asking for reduced motion has to be
     opted back out here. The toggle is what makes a 35s loop WCAG 2.2.2 compliant. */
  var heroVid = document.querySelector('.hero-vid video');
  var heroVidBtn = document.querySelector('[data-vid-toggle]');
  if (heroVid && heroVidBtn) {
    if (calm) { heroVid.autoplay = false; heroVid.pause(); }
    var syncVidBtn = function () {
      var paused = heroVid.paused;
      heroVidBtn.querySelector('i').className = paused ? 'fa-solid fa-play' : 'fa-solid fa-pause';
      heroVidBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    };
    heroVidBtn.addEventListener('click', function () {
      if (heroVid.paused) { heroVid.play(); } else { heroVid.pause(); }
    });
    heroVid.addEventListener('play', syncVidBtn);
    heroVid.addEventListener('pause', syncVidBtn);
    syncVidBtn();
  }

  if (!calm && 'IntersectionObserver' in window) {
    /* [selector, stagger step in ms, variant] */
    var GROUPS = [
      ['.shead', 0, ''],
      ['.press', 0, ''],
      ['.rail > *', 70, 'zoom'],
      ['.probs > *', 70, 'zoom'],
      ['.inside > *', 70, 'zoom'],
      ['.ing-list li', 45, ''],
      ['.ing-shot', 0, 'zoom'],
      ['.ing-free span', 60, ''],
      ['.ba-compare', 0, 'zoom'],
      ['.ba-copy', 0, ''],
      ['.vid-head', 0, ''],
      ['.vid-pts li', 60, ''],
      ['.pull', 0, ''],
      ['.ritual-head', 0, ''],
      ['.rit', 70, ''],
      ['.weeks > *', 70, ''],
      ['.guar', 0, 'zoom'],
      ['.cmp-scroll', 0, ''],
      ['.rsum', 0, ''],
      ['.specs > div', 30, ''],
      ['.fq', 40, ''],
      ['.gal', 0, 'zoom'],
      ['.buy > *', 45, '']
    ];

    /* the observer's first callback is the only "what is on screen right now" check: no
       getBoundingClientRect at boot, which would force layout of every content-visibility
       section. Whatever is already visible shows at once (.now), the rest fades in on scroll. */
    var firstPass = true;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        if (firstPass) e.target.classList.add('now');
        io.unobserve(e.target);
      });
      firstPass = false;
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.02 });

    GROUPS.forEach(function (g) {
      var sel = g[0], step = g[1], variant = g[2];
      var byParent = new Map();
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('.hero-copy') || el.hasAttribute('data-anim')) return;
        el.setAttribute('data-anim', variant);
        /* stagger within each parent so siblings cascade, not the whole page */
        var n = byParent.get(el.parentNode) || 0;
        byParent.set(el.parentNode, n + 1);
        if (step && n) el.style.transitionDelay = Math.min(n * step, 400) + 'ms';
        io.observe(el);
      });
    });

  }

  /* ---------- deferred below-the-fold images ----------
   Cards below the fold hold their URL in data-lazysrc instead of src. Chrome fetches a
   loading="lazy" image up to 3000px away on a slow connection, and Lighthouse charges every
   byte that lands before the hero paints against LCP — so the fetch has to be ours to time.
   rootMargin is generous: the image is requested about three screens early, which is long
   before a scrolling reader can reach it. */
  (function () {
    var lazy = [].slice.call(document.querySelectorAll('img[data-lazysrc]'));
    if (!lazy.length) return;
    var hydrate = function (img) {
      if (img.dataset.lazysrcset) img.srcset = img.dataset.lazysrcset;
      if (img.dataset.lazysrc) img.src = img.dataset.lazysrc;
      delete img.dataset.lazysrc; delete img.dataset.lazysrcset;
    };
    if (!('IntersectionObserver' in window)) { lazy.forEach(hydrate); return; }
    var lio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        hydrate(e.target);
        lio.unobserve(e.target);
      });
    }, { rootMargin: '150% 0px' });
    lazy.forEach(function (img) { lio.observe(img); });
    /* deliberately no blanket timeout fallback: forcing every pending image after load pulled
       in three sections' worth of pictures that a reader who never scrolls should not pay for
       (it added 95 KiB and put them back before the hero painted). The observer is the only
       trigger; the no-IntersectionObserver branch above covers the one browser that lacks it. */
  })();

  /* ---------- before / after compare slider ----------
     Pointer-driven rather than leaning on the invisible native range: an
     opacity-0 range is unreliable to drag on touch. The range is kept for
     keyboard and screen readers and stays in sync. */
  document.querySelectorAll('.ba-compare').forEach(function (box) {
    var range = box.querySelector('.ba-range');

    var set = function (pct) {
      pct = Math.max(0, Math.min(100, pct));
      box.style.setProperty('--x', pct + '%');
      if (range) range.value = pct;
    };
    var pctFromX = function (clientX) {
      var r = box.getBoundingClientRect();
      return ((clientX - r.left) / r.width) * 100;
    };

    if (range) {
      range.addEventListener('input', function () { set(parseFloat(range.value)); });
      set(parseFloat(range.value));
    } else {
      set(50);
    }

    var id = null, x0 = 0, y0 = 0, dragging = false;

    box.addEventListener('pointerdown', function (e) {
      id = e.pointerId; x0 = e.clientX; y0 = e.clientY;
      dragging = e.pointerType === 'mouse';
      if (dragging) { box.setPointerCapture(id); set(pctFromX(e.clientX)); }
    });

    box.addEventListener('pointermove', function (e) {
      if (e.pointerId !== id) return;
      if (!dragging) {
        var dx = Math.abs(e.clientX - x0), dy = Math.abs(e.clientY - y0);
        if (dx < 6 && dy < 6) return;
        if (dy > dx) { id = null; return; }   /* vertical intent — let the page scroll */
        dragging = true;
        box.setPointerCapture(id);
      }
      e.preventDefault();
      set(pctFromX(e.clientX));
    });

    var end = function () {
      if (id === null) return;
      if (box.hasPointerCapture && box.hasPointerCapture(id)) box.releasePointerCapture(id);
      id = null; dragging = false;
    };
    box.addEventListener('pointerup', end);
    box.addEventListener('pointercancel', end);
  });

  /* ---------- stat count-up ---------- */
  var stats = document.querySelectorAll('.stat b');
  if (stats.length && !calm && 'IntersectionObserver' in window) {
    var sio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        sio.unobserve(e.target);
        var el = e.target;
        var target = parseInt(el.textContent, 10);
        if (isNaN(target)) return;
        var suffix = el.textContent.replace(/[0-9]/g, '');
        var t0 = null;
        var tick = function (t) {
          if (t0 === null) t0 = t;
          var p = Math.min((t - t0) / 1100, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.6 });
    stats.forEach(function (s) { sio.observe(s); });
  }
})();

/* ==========================================================================
   Cart drawer — CRO Playbook Module 11.
   Seven elements: product summary · micro proof · guarantee · visual clarity ·
   relevant upsell · pricing and savings · one strong CTA into checkout.
   ========================================================================== */
(function () {
  'use strict';

  var el = document.getElementById('cart');
  if (!el) return;

  /* Every product the current page knows about: the drawer section registers the
     suggestion collection, the PDP registers the product being viewed. Both run inline
     before this deferred file. No hard-coded catalogue — the store is the source. */
  var CATALOG = window.CGCart_CATALOG_OVERRIDE || {};
  var RITUAL = (window.CGCart_SUGGEST || Object.keys(CATALOG)).filter(function (k) { return CATALOG[k]; });

  var store = window.CGShopifyCart;
  if (!store) return;
  var $ = function (id) { return document.getElementById(id); };
  var money = function (n) { return store.money(Math.round(n * 100)); };
  var items = [];
  var find = function (k) { return items.find(function (i) { return i.k === k; }); };
  var dataOf = function (it) { return { n: it.n, s: it.s, img: it.img, v: it.v }; };
  // Prices, discounts and line keys come from Shopify, including products added elsewhere.
  var unitOf = function (it) { return it.unit / 100; };
  var cUnitOf = function (it) { return it.original / 100; };
  var lineTotal = function (it) { return it.total / 100; };
  var subtotal = function () { return store.get().total_price / 100; };
  var compareAt = function () { return store.get().original_total_price / 100; };
  var count = function () { return store.get().item_count; };
  function receiveCart(cart) {
    items = cart.items.map(function (line) {
      return { k: line.key, handle: line.handle, q: line.quantity, n: line.product_title,
        s: line.variant_title === 'Default Title' ? '' : line.variant_title,
        img: line.image || '', v: line.variant_id, unit: line.final_price,
        original: line.original_price, total: line.final_line_price };
    });
    render();
    setBusy(store.busy());
  }
  function setBusy(busy) {
    el.setAttribute('aria-busy', String(busy));
    $('cartGo').disabled = busy || !count();
    el.querySelectorAll('[data-q], [data-del], [data-add]').forEach(function (button) {
      var line = find(button.dataset.q);
      button.disabled = busy || !!(line && Number(button.dataset.d) > 0 && line.q >= 9);
    });
  }
  window.addEventListener('cg:cart-updated', function (event) { receiveCart(event.detail); });
  window.addEventListener('cg:cart-busy', function (event) { setBusy(event.detail); });
  window.addEventListener('cg:cart-error', function (event) {
    $('cartNote').textContent = event.detail;
    $('cartNote').hidden = false;
  });

  /* which creams the cart already covers, bundles included */
  var covered = function () {
    var set = {};
    items.forEach(function (i) { set[i.handle] = true; });
    return set;
  };

  /* Adding N of something means the line IS N — the tier the customer picked, not N
     more on top of whatever was there. Anything else and the ladder silently re-prices
     a line the customer didn't touch. */
  function add(k, q, bump) {
    var d = CATALOG[k];
    if (!d || !d.v) return;
    $('cartNote').hidden = true;
    return store.add(d.v, Math.min(9, Math.max(1, q || 1)), bump);
  }
  function setQty(k, q) {
    if (!find(k)) return;
    $('cartNote').hidden = true;
    return store.change(k, Math.max(0, Math.min(9, q)));
  }

  /* shipping rule, set on the cart drawer section */
  var SHIP = window.CGCart_SHIPPING || {
    threshold: 80, rate: 7.95,
    freeText: 'Free shipping · arrives',
    paidText: '{rate} shipping · arrives'
  };

  /* delivery expectations — checkout rule 4 */
  var eta = (function () {
    var f = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', day: 'numeric', month: 'short' }); };
    var a = new Date(), b = new Date();
    a.setDate(a.getDate() + 3); b.setDate(b.getDate() + 6);
    return f(a) + ' – ' + f(b);
  })();

  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); };

  /* one row, one look: the drawer's upsells, the empty state and the search results all
     render through here, so they can't drift apart. cta is a button when the page knows
     the product well enough to add it, a link to the product otherwise. */
  function cuRow(d, cta) {
    return '<div class="cu"><img src="' + d.img + '" alt="" width="54" height="54" loading="lazy">' +
      '<div><p class="cu-n">' + esc(d.n) + '</p>' +
      /* base price only for a single product; a bundle's catalogue compare is its contents
         value, so the strike here is a real saving and matches its card and PDP */
      '<p class="cu-p">' + money(d.p) + (d.c > d.p ? '<s>' + money(d.c) + '</s>' : '') + '</p></div>' +
      cta + '</div>';
  }

  function upsellRow(k, label) {
    return cuRow(CATALOG[k], '<button class="cu-go" data-add="' + k + '">' + (label || 'Add') + '</button>');
  }

  function render() {
    var n = count(), empty = n === 0;

    $('cartCount').textContent = empty ? '' : '(' + n + ')';
    $('cartEta').textContent = eta;
    $('cartEmpty').hidden = !empty;
    $('cartFoot').hidden = empty;
    $('cartList').hidden = empty;
    document.querySelector('.cart-ship').hidden = empty;

    /* ---- line items ---- */
    $('cartList').innerHTML = items.map(function (it) {
      var d = dataOf(it), t = lineTotal(it), was = cUnitOf(it) * it.q;
      var saved = was - t;
      return '<li class="ci">' +
        '<img class="ci-img" src="' + d.img + '" alt="" width="74" height="74">' +
        '<div class="ci-b">' +
          '<div class="ci-h"><div><p class="ci-n">' + esc(d.n) + '</p></div>' +
          '<button class="ci-x" data-del="' + it.k + '" aria-label="Remove ' + esc(d.n) + '"><i class="fa-solid fa-xmark"></i></button></div>' +
          (saved >= 0.005
            ? '<span class="ci-save"><i class="fa-solid fa-tag"></i>' + money(unitOf(it)) +
              ' each · saving ' + money(saved) + '</span>'
            : '') +
          '<div class="ci-r">' +
            '<div class="ci-q">' +
              '<button data-q="' + it.k + '" data-d="-1" aria-label="Decrease"><i class="fa-solid fa-minus"></i></button>' +
              '<b>' + it.q + '</b>' +
              '<button data-q="' + it.k + '" data-d="1" aria-label="Increase"' + (it.q >= 9 ? ' disabled' : '') + '><i class="fa-solid fa-plus"></i></button>' +
            '</div>' +
            '<p class="ci-p">' + money(t) + (was - t >= 0.005 ? '<s>' + money(was) + '</s>' : '') + '</p>' +
          '</div>' +

        '</div></li>';
    }).join('');

    /* ---- completion upsell: only creams the cart doesn't already cover ---- */
    var have = covered();
    var missing = RITUAL.filter(function (k) { return !have[k]; }).slice(0, 2);
    $('cartAdd').hidden = empty || !missing.length;
    $('addList').innerHTML = missing.map(function (k) { return upsellRow(k); }).join('');

    /* ---- empty state doubles as a shortcut back in ---- */
    if (empty) $('emptyList').innerHTML = RITUAL.map(function (k) { return upsellRow(k); }).join('');

    /* ---- pricing and savings ---- */
    var sub = subtotal(), saved = compareAt() - sub;

    /* free-shipping progress: message + how full the bar is */
    var shipEl = $('cartShipMsg'), fill = $('cartShipFill');
    var free = sub >= SHIP.threshold;
    if (shipEl) {
      shipEl.textContent = free
        ? SHIP.freeText
        : SHIP.paidText.replace('{rate}', money(SHIP.rate)).replace('{more}', money(SHIP.threshold - sub));
    }
    if (fill) {
      fill.style.width = Math.min(100, Math.round(sub / SHIP.threshold * 100)) + '%';
      fill.parentNode.classList.toggle('done', free);
    }
    var shipWrap = document.querySelector('.cart-ship');
    if (shipWrap) shipWrap.classList.toggle('free', free);

    $('cartSub').textContent = money(sub);
    $('cartGoV').textContent = money(sub);
    /* half a cent, not zero: float drift on a sum of thirds must not render "−$0.00" */
    $('cartSav').hidden = saved < 0.005;
    $('cartSavV').textContent = '−' + money(saved);

    /* ---- header bag count ---- */
    document.querySelectorAll('.icn-btn.cart').forEach(function (b) {
      var badge = b.querySelector('.cart-n');
      if (!badge) {
        badge = document.createElement('b');
        badge.className = 'cart-n';
        /* the digit is decorative: it is announced through the button's own name instead,
           otherwise the visible text and the accessible name disagree */
        badge.setAttribute('aria-hidden', 'true');
        b.appendChild(badge);
      }
      badge.textContent = n;
      badge.hidden = empty;
      b.classList.toggle('has', !empty);
      if (!b.dataset.label) b.dataset.label = b.getAttribute('aria-label') || 'Cart';
      b.setAttribute('aria-label', empty ? b.dataset.label
        : b.dataset.label + ', ' + n + (n === 1 ? ' item' : ' items'));
    });
  }

  /* ---- open / close ---- */
  var scrim = $('cartScrim'), opener = null;
  function open() {
    opener = document.activeElement;
    el.hidden = false; scrim.hidden = false;
    requestAnimationFrame(function () { el.classList.add('on'); scrim.classList.add('on'); });
    document.body.style.overflow = 'hidden';
    $('cartClose').focus();
  }
  function close() {
    el.classList.remove('on'); scrim.classList.remove('on');
    document.body.style.overflow = '';
    setTimeout(function () { el.hidden = true; scrim.hidden = true; }, 380);
    if (opener && opener.focus) opener.focus();
  }

  document.querySelectorAll('.icn-btn.cart').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });
  $('cartClose').addEventListener('click', close);
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });

  /* [data-add] is handled on the document, not the drawer, so an Add button anywhere on the
     page works — product cards, the drawer's own upsells, wherever one lands next. A click
     from outside the drawer opens it, which is the only feedback the shopper gets; a click
     inside it is already looking at the result. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-add]');
    if (!b) return;
    e.preventDefault();
    add(b.dataset.add, 1, true);
    if (!el.contains(b)) open();
  });

  el.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    if (b.dataset.del) { setQty(b.dataset.del, 0); return; }
    if (b.dataset.q) {
      var it = find(b.dataset.q);
      if (it) setQty(it.k, it.q + Number(b.dataset.d));
    }
  });

  // Both checkout buttons use the same Shopify cart; no permalink rebuild is needed.
  $('cartGo').addEventListener('click', function () {
    if (store.busy() || !count()) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = root + 'checkout';
  });

  /* ---------- search drawer: same shell, same rows, live products ----------
     Shopify's predictive-search endpoint, rendered through cuRow so a result and a
     suggestion are the same object. No query = the drawer's own suggestions. */
  (function () {
    var sd = $('searchDrawer');
    if (!sd) return;

    var COPY = window.CGSearch_COPY || {};
    var scrim = $('searchScrim'), input = $('searchInput'), list = $('searchList');
    var head = $('searchHead'), none = $('searchEmpty'), all = $('searchAll');
    var opener = null, seq = 0;

    function suggestions() {
      head.textContent = COPY.suggest || 'You may also like';
      list.innerHTML = RITUAL.slice(0, 4).map(function (k) { return upsellRow(k, COPY.add); }).join('');
      none.hidden = true; all.hidden = true;
    }

    /* suggest.json prices are decimal strings in the shop currency */
    function num(v) { return Math.round(parseFloat(v || 0) * 100) / 100; }

    function results(products, q) {
      head.textContent = COPY.results || 'Products';
      list.innerHTML = products.map(function (p) {
        var k = p.handle, known = CATALOG[k];
        var d = {
          n: p.title,
          /* &width=160 keeps the row from pulling a 1200px original into a 54px slot */
          img: p.featured_image && p.featured_image.url ? p.featured_image.url + '&width=160' : (known || {}).img || '',
          p: known ? known.p : num(p.price),
          c: known ? known.c : num(p.compare_at_price)
        };
        /* a product the page has registered can go straight into the cart, exactly like a
           suggestion row; anything else opens its page */
        return cuRow(d, known
          ? '<button class="cu-go" data-add="' + k + '">' + (COPY.add || 'Add') + '</button>'
          : '<a class="cu-go" href="' + p.url + '">' + (COPY.view || 'View') + '</a>');
      }).join('');
      none.hidden = products.length > 0;
      all.hidden = false;
      all.href = '/search?q=' + encodeURIComponent(q);
    }

    function query(q) {
      if (!q) { suggestions(); return; }
      var mine = ++seq;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=' + (COPY.limit || 6))
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (mine !== seq) return; /* a slower earlier request must not overwrite a newer one */
          results((j.resources && j.resources.results && j.resources.results.products) || [], q);
        })
        .catch(function () { if (mine === seq) { list.innerHTML = ''; none.hidden = false; } });
    }

    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      timer = setTimeout(function () { query(q); }, 250);
    });

    function openSearch() {
      opener = document.activeElement;
      sd.hidden = false; scrim.hidden = false;
      requestAnimationFrame(function () { sd.classList.add('on'); scrim.classList.add('on'); });
      document.body.style.overflow = 'hidden';
      input.focus();
    }
    function closeSearch() {
      sd.classList.remove('on'); scrim.classList.remove('on');
      document.body.style.overflow = '';
      setTimeout(function () { sd.hidden = true; scrim.hidden = true; }, 380);
      if (opener && opener.focus) opener.focus();
    }

    document.querySelectorAll('[data-search-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
    });
    $('searchClose').addEventListener('click', closeSearch);
    scrim.addEventListener('click', closeSearch);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sd.hidden) closeSearch(); });
    /* an Add from a search row belongs in the cart drawer, so hand over */
    sd.addEventListener('click', function (e) { if (e.target.closest('button[data-add]')) closeSearch(); });

    suggestions();
    window.CGSearch = { open: openSearch, close: closeSearch };
  })();

  receiveCart(store.get());
  window.CGCart = { add: add, open: open, close: close };
  if (new URLSearchParams(window.location.search).get('cart') === 'true') open();
})();

/* ==========================================================================
   Video proof — vertical clips that hand off to the next when they end.
   Muted + playsinline so mobile will autoplay at all; nothing downloads until
   the section is actually on screen. Clip count and captions come from the
   section's blocks, so adding or removing a clip in the editor just works.
   ========================================================================== */
(function () {
  'use strict';

  var frame = document.getElementById('vidFrame');
  if (!frame) return;

  var vids  = [].slice.call(frame.querySelectorAll('.vs'));
  var bars  = [].slice.call(document.querySelectorAll('#vidBars .vb'));
  var sound = document.getElementById('vidSound');
  var playB = document.getElementById('vidPlay');
  var title = document.getElementById('vidTitle');
  var meta  = document.getElementById('vidMeta');
  if (!vids.length || bars.length !== vids.length) return;

  var i = 0, inView = false, muted = true, wanted = false, raf = null;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* posters are fetched only once the section is within a screen of view: a poster attribute
     downloads at parse time, and the clips sit far below the fold */
  var hydrate = function () {
    vids.forEach(function (v) { if (v.dataset.poster) { v.poster = v.dataset.poster; delete v.dataset.poster; } });
  };
  if ('IntersectionObserver' in window) {
    var pio = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { hydrate(); pio.disconnect(); }
    }, { rootMargin: '100% 0px' });
    pio.observe(frame);
  } else {
    hydrate();
  }
  /* don't spend someone's data plan without being asked */
  var conn = navigator.connection || {};
  var thrifty = conn.saveData === true || /^(slow-)?2g$/.test(conn.effectiveType || '');
  var hold = calm || thrifty;

  var clock = function (s) {
    if (!isFinite(s)) return '';
    return Math.floor(s / 60) + ':' + ('0' + Math.floor(s % 60)).slice(-2);
  };
  var label = function (v) {
    return 'Clip ' + (i + 1) + ' of ' + vids.length + (v && v.duration ? ' · ' + clock(v.duration) : '');
  };

  function paint() {
    var v = vids[i];
    var pct = v.duration ? (v.currentTime / v.duration) * 100 : 0;
    bars[i].querySelector('.vb-f').style.width = Math.min(100, pct) + '%';
    if (v.duration) meta.textContent = label(v);
    if (!v.paused) raf = requestAnimationFrame(paint);
  }

  function show(n, autoplay) {
    var prev = vids[i];
    prev.pause();
    prev.currentTime = 0;
    prev.classList.remove('on');

    i = n;
    vids[i].classList.add('on');
    bars.forEach(function (b, k) {
      b.classList.toggle('on', k === i);
      b.classList.toggle('done', k < i);
      if (k !== i) b.querySelector('.vb-f').style.width = k < i ? '100%' : '0';
    });
    title.textContent = vids[i].dataset.title || '';
    meta.textContent = label(vids[i]);
    if (autoplay) start(); else frame.classList.add('paused');
  }

  function start() {
    var v = vids[i];
    v.muted = muted;
    var p = v.play();
    if (p && p.catch) p.catch(function () { frame.classList.add('paused'); });
  }

  vids.forEach(function (v, n) {
    v.addEventListener('play',  function () {
      frame.classList.remove('paused');
      cancelAnimationFrame(raf); raf = requestAnimationFrame(paint);
    });
    v.addEventListener('pause', function () {
      cancelAnimationFrame(raf);
      if (!v.ended) frame.classList.add('paused');
    });
    v.addEventListener('loadedmetadata', function () {
      if (n === i) meta.textContent = label(v);
    });
    /* hand off to the next clip, wrapping back to the first */
    v.addEventListener('ended', function () {
      bars[n].querySelector('.vb-f').style.width = '100%';
      show((n + 1) % vids.length, inView && wanted);
    });
  });

  bars.forEach(function (b) {
    b.addEventListener('click', function () {
      wanted = true;
      show(Number(b.dataset.i), true);
    });
  });

  playB.addEventListener('click', function () {
    wanted = true;
    if (vids[i].paused) { start(); } else { vids[i].pause(); }
  });

  /* arrows step through the same clips the bars address, wrapping both ways */
  function step(d) {
    return function () {
      wanted = true;
      show((i + d + vids.length) % vids.length, true);
    };
  }
  var prevB = document.getElementById('vidPrev');
  var nextB = document.getElementById('vidNext');
  if (prevB) prevB.addEventListener('click', step(-1));
  if (nextB) nextB.addEventListener('click', step(1));

  sound.addEventListener('click', function () {
    muted = !muted;
    vids.forEach(function (v) { v.muted = muted; });
    sound.innerHTML = '<i class="fa-solid fa-volume-' + (muted ? 'xmark' : 'high') + '"></i>';
    sound.setAttribute('aria-label', muted ? 'Turn sound on' : 'Turn sound off');
    if (!muted && vids[i].paused) { wanted = true; start(); }
  });

  /* only spend bandwidth once the section is actually being looked at */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        inView = e.isIntersecting;
        if (inView) {
          if (hold && !wanted) { frame.classList.add('paused'); return; }
          wanted = true; start();
        } else {
          vids[i].pause();
        }
      });
    }, { threshold: 0.45 }).observe(frame);
  } else {
    frame.classList.add('paused');
  }

  title.textContent = vids[0].dataset.title || '';
  meta.textContent = label(vids[0]);
  frame.classList.add('paused');
})();

/* ==========================================================================
   Reviews anchor — the rating link at the top of the PDP points at #reviews,
   but that id belongs to the theme's own reviews section, which is switched
   off on templates that use a reviews app instead. When it is missing, fall
   back to the app's widget so the link still lands somewhere. Resolved at
   click time, so a widget that loads late is still found.
   ========================================================================== */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#reviews"]');
    /* the section is present: let the browser's own anchor handling do it */
    if (!a || document.getElementById('reviews')) return;

    var w = document.querySelector('.jdgm-widget');
    if (!w) return;

    e.preventDefault();
    /* scroll-padding-top on <html> keeps the target clear of the sticky header */
    (w.closest('.shopify-section') || w).scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

/* ==========================================================================
   Product description tidy — rich text pasted into the admin leaves paragraphs
   holding nothing but &nbsp; between blocks, and each one costs a full blank
   line on the PDP. No CSS selector can reach them: :empty does not match a
   non-breaking space. Anything carrying media is left alone, so only genuinely
   blank paragraphs go.
   ========================================================================== */
(function () {
  'use strict';

  var lede = document.querySelector('.buy .lede');
  if (!lede) return;

  [].forEach.call(lede.querySelectorAll('p'), function (p) {
    /* trim() drops U+00A0 too, so an &nbsp;-only paragraph reads as empty here */
    if (!p.textContent.trim() && !p.querySelector('img,iframe,video,svg,picture')) p.remove();
  });

  /* the same editor doubles up <br> between a bold label and its body — one inside the
     <strong>, one after it — which reads as a blank line. They sit in different parents, so
     compare by document position: a break with nothing but whitespace since the last one is
     redundant. Collapsing to a single break keeps the label on its own line without the gap. */
  [].forEach.call(lede.querySelectorAll('p'), function (p) {
    var prev = null;
    [].forEach.call(p.querySelectorAll('br'), function (br) {
      if (prev) {
        var gap = document.createRange();
        gap.setStartAfter(prev);
        gap.setEndBefore(br);
        if (!gap.toString().trim()) { br.remove(); return; }
      }
      prev = br;
    });
  });
})();
